import React, { useMemo } from "react";
import { SHCheckbox } from "@components/design-systems";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "@redux/store";
import { isEmpty } from "lodash";
import {
  deselectAllDisplayingRowIds,
  selectAllDisplayingRowIds,
} from "@redux/slices/model-screener";

export const MSTableSelectedAllRowCheckbox = React.memo(() => {
  const dispatch = useAppDispatch();

  const displayingRowIds = useSelector(
    (state: RootState) => state.modelScreener.internal.displayingRowIds,
  );
  const selectedRowIds = useSelector(
    (state: RootState) => state.modelScreener.selectedRowIds,
  );

  const displayingRowKeys = useMemo(
    () => Object.keys(displayingRowIds),
    [displayingRowIds],
  );

  const isChecked = useMemo(() => {
    if (isEmpty(displayingRowKeys) || isEmpty(selectedRowIds)) return false;

    const selectedFilteredData = displayingRowKeys.filter(
      (rowId) => !!selectedRowIds[rowId],
    );

    return displayingRowKeys.length === selectedFilteredData.length;
  }, [displayingRowKeys, selectedRowIds]);

  const handleOnCheckboxClicked = () => {
    dispatch(
      isChecked ? deselectAllDisplayingRowIds() : selectAllDisplayingRowIds(),
    );
  };

  return <SHCheckbox checked={isChecked} onChange={handleOnCheckboxClicked} />;
});
